import config from 'configDir/index';
import { post, get, put, del } from './http';

// 查询自定义表单接口
const queryCustomFormService = get('/customForm', config.commonServiceUrl);

// 新增自定义表单接口
const addCustomFormService = post('/customForm', config.commonServiceUrl);

// 修改自定义表单接口
const updateCustomFormService = put('/customForm', config.commonServiceUrl);

// 删除自定义表单接口
const deleteCustomFormService = del('/customForm', config.commonServiceUrl);

export {
  // eslint-disable-next-line import/prefer-default-export
  queryCustomFormService,
  addCustomFormService,
  updateCustomFormService,
  deleteCustomFormService,
};
